/**
 * Валюта и формат цен по настройкам ресторана (UZS / RUB).
 */
export const DEFAULT_CURRENCY = 'UZS';

export function normalizeCurrency(currency) {
  if (!currency) return 'UZS';
  const u = String(currency).toUpperCase();
  if (u === 'RUB' || u === 'RUR') return 'RUB';
  return 'UZS';
}

export function formatRestaurantPrice(amount, currency = 'UZS') {
  const n = Number(amount);
  if (Number.isNaN(n)) return '—';
  const c = normalizeCurrency(currency);
  if (c === 'RUB') {
    return `${n.toLocaleString('ru-RU', { maximumFractionDigits: 0 })} ₽`;
  }
  return `${n.toLocaleString('uz-UZ')} сум`;
}

/** Пресеты сегмента: влияют на подсказки и дефолт валюты при смене в форме */
export const MARKET_SEGMENTS = [
  { value: 'central_asia', label: 'Центральная Азия', hint: 'сум · Instagram / Telegram / WhatsApp' },
  { value: 'russia', label: 'Россия', hint: '₽ · VK · MAX' },
  { value: 'custom', label: 'Свой вариант', hint: 'любая валюта и соцсети' },
];

export function segmentDefaultCurrency(segment) {
  if (segment === 'russia') return 'RUB';
  return 'UZS';
}

/** VK: полная ссылка или screen name */
export function vkHref(raw) {
  if (!raw || !String(raw).trim()) return null;
  const s = String(raw).trim();
  if (/^https?:\/\//i.test(s)) return s;
  const path = s.replace(/^vk\.com\//i, '').replace(/^\//, '');
  return `https://vk.com/${path}`;
}

/** MAX: только ссылка как есть или https если похоже на путь */
export function maxMessengerHref(raw) {
  if (!raw || !String(raw).trim()) return null;
  const s = String(raw).trim();
  if (/^https?:\/\//i.test(s)) return s;
  return `https://max.ru/${s.replace(/^\//, '')}`;
}
